import {
    AtmIcon,
    BabyCarIcon,
    ConvenienceIcon,
    ElevatorIcon,
    EscalatorIcon,
    InfoCircleIcon,
    KidIcon,
    NursingRoomIcon,
    PremiumIcon,
    RepairIcon,
    RestroomForDisabledIcon,
    RestroomIcon,
    TaxRefundIcon,
} from '@/components/icons/facility';
import type { SVGProps } from 'react';

export type FacilityCategoryIconProps = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export type FacilityCategoryIconComponent = (props: FacilityCategoryIconProps) => React.JSX.Element;

const FACILITY_CATEGORY_ICON_BY_CLIENT_CODE: Record<string, FacilityCategoryIconComponent> = {
    '13': InfoCircleIcon,
    '14': RestroomIcon,
    '15': NursingRoomIcon,
    '16': KidIcon,
    '17': ElevatorIcon,
    '18': EscalatorIcon,
    '20': RestroomForDisabledIcon,
    '21': BabyCarIcon,
    '22': RepairIcon,
    '23': AtmIcon,
    '24': TaxRefundIcon,
    '25': ConvenienceIcon,
    '26': PremiumIcon,
};

export const getFacilityCategoryIconComponent = (clientCode: string): FacilityCategoryIconComponent | null => {
    return FACILITY_CATEGORY_ICON_BY_CLIENT_CODE[clientCode] ?? null;
};
